import React, { Component } from 'react';
import FilterMain from './FilterMainConnected';
import Panels from '../Panels'
import Modal from 'react-modal';
import {
  WidgetPieDrillVisits,
  WidgetPieDrillConversion,
  WidgetPieDrillSubs,
  WidgetPieDrillUnsubs
} from '../../ConnectedWidgets';
import './PanelHome.css';

const colorSchemeArray = ["#5053b3", "#8285ff" , "#c1c3ff", "#df5e00", "#ee8800", "#feaf46"]

const drillMaps = {
  'WidgetPieDrillVisits': WidgetPieDrillVisits,
  'WidgetPieDrillConversion': WidgetPieDrillConversion,
  'WidgetPieDrillSubs': WidgetPieDrillSubs,
  'WidgetPieDrillUnsubs': WidgetPieDrillUnsubs
}

export default class HomePanel extends Panels {
  constructor(props) {
    super(props);
    this.state = {
      widgets: {
        WidgetSubs: {
          height: 300,
          width: window.innerWidth > 800 ? window.innerWidth * 0.425 : window.innerWidth * 0.9,
          className: window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn',
          colorScheme: colorSchemeArray,
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetSubs') : null,
          drillClick: (params) => this.setState({ drillData: params, modal: true}),
          title: 'Subscribers'
        },
        WidgetUnsubs: {
          height: 300,
          width: window.innerWidth > 800 ? window.innerWidth * 0.425 : window.innerWidth * 0.9,
          className: window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn',
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetUnsubs') : null,
          colorScheme: colorSchemeArray,
          drillClick: (params) => this.setState({ drillData: params, modal: true}),
          title: 'Unsubscribers'
        },
        WidgetBilling: {
          height: 300,
          width: window.innerWidth > 800 ? window.innerWidth * 0.425 : window.innerWidth * 0.9,
          className: window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn',
          colorScheme: colorSchemeArray,
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetBilling') : null,
          title: 'Billing Report'
        },
        WidgetRevenue: {
          height: 300,
          width: window.innerWidth > 800 ? window.innerWidth * 0.425 : window.innerWidth * 0.9,
          className: window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn',
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetRevenue') : null,
          colorScheme: colorSchemeArray,
          title: 'Revenue'
        },
        WidgetVisits: {
          height: 300,
          width: window.innerWidth > 800 ? window.innerWidth * 0.425 : window.innerWidth * 0.9,
          className: window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn',
          colorScheme: colorSchemeArray,
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetVisits') : null,
          drillClick: (params) => this.setState({ drillData: params, modal: true}),
          title: 'Visits'
        },
        WidgetConversion: {
          height: 300,
          width: window.innerWidth > 800 ? window.innerWidth * 0.525 : window.innerWidth * 0.9,
          className: window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn',
          colorScheme: colorSchemeArray,
          onZoom: window.innerWidth > 800 ? this.zoom('WidgetConversion') : null,
          drillClick: (params) => this.setState({ drillData: params, modal: true}),
          title: 'Conversion'
        }
      }
    }
  }

  closeModal = () => this.setState({ modal: false })

  render() {
    const DrillComponent = this.state.drillData ? drillMaps[this.state.drillData.widgetType] : <div />
    return (
      <div className="HomePanel">
        <Modal
          isOpen={this.state.modal}
          onRequestClose={this.closeModal}
          contentLabel="Modal"
          style={{content: {
            top: '25%',
            left: '20%',
            bottom: null,
            right: null,
            width: this.state && this.state.drillData && this.state.drillData.widgetType === 'WidgetPieDrillVisits' ? '50%' : null,
          }}}
        >
          <DrillComponent
            colorScheme={colorSchemeArray}
            title={this.state.drillData ? this.state.drillData.widgetTitle : ''}
            filters={{
              ...this.state.drillData,
              ...(this.state.drillData ? this.state.drillData.filters : {})
            }}
            close={this.closeModal}
            height={300}
            width={window.innerWidth > 800 ? window.innerWidth * 0.3 : window.innerWidth * 0.9}
            className={window.innerWidth > 800 ? 'zoomedOut' : 'zoomedIn'}
          />
        </Modal>
        <div className="panel-content">
          <FilterMain />
          {this.renderWidgets()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Panels/PanelHomeComponent/PanelHome.js